import { Controller } from "@hotwired/stimulus";

// Live "Suggested professionals" while composing a job (M10). Watches the
// profession + date fields and points the preview turbo-frame at
// /jobs/preview_matches, so matches update as the poster fills the form.
export default class extends Controller {
  static values = { url: String };

  connect() {
    this.refresh = this.refresh.bind(this);
    this.element.addEventListener("change", this.refresh);
    this.refresh();
  }

  disconnect() {
    this.element.removeEventListener("change", this.refresh);
  }

  refresh() {
    const frame = this.element.querySelector("#job_matches_preview");
    if (!frame) return;

    // LOC-081: every chosen profession row, in order.
    const professions = Array.from(this.element.querySelectorAll("[data-locals-job-profession]"))
      .filter((el) => !el.closest("[hidden]"))
      .map((el) => el.value.trim())
      .filter(Boolean);
    if (professions.length === 0) {
      frame.removeAttribute("src");
      frame.innerHTML = "";
      return;
    }

    const params = new URLSearchParams();
    professions.forEach((profession) => params.append("professions[]", profession));
    const start = this.field("start_date");
    const end = this.field("end_date");
    if (start) params.set("start_date", start);
    if (end) params.set("end_date", end);

    frame.src = `${this.urlValue}?${params.toString()}`;
  }

  field(name) {
    const el = this.element.querySelector(`[name="locals_job_posting[${name}]"]`);
    return el ? el.value.trim() : "";
  }
}
